import React from "react";
import { Link } from 'react-router-dom';
import jwt from 'jsonwebtoken';
//
import isAdmin from '../../services/admin';
import { Be } from './styles'
import { logout, getToken } from '../../services/auth';
import { FaHome, FaInfo, FaChevronDown } from 'react-icons/fa';

import Profile from '../../assets/profile.png';

import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'

export default function Left() {  

  const data = jwt.decode(localStorage.getItem('@unknown'));

  function profileinfo(){
    var click = document.getElementById('drop-contentp');
    if (click.style.display === 'none'){
      click.style.display = 'block';
      click.style.transform = 'translateY(0)';
      click.style.opacity = '1';
    } else {
      click.style.display = 'none'
    }
  }

  function sair(){
    logout();
    setTimeout(() => {
      store.addNotification({
        title: "INFO",
        message: "Saiste da conta com sucesso.",
        type: "warning",
        insert: "bottom",
        container: "bottom-left",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3500,
          onScreen: true
        }
      });
    }, 200);
  }

  return (
    <>
      <Be>
        <div className="account-detailes">
          <img src={Profile} alt="logo" className="profile-pic"/>
          <ul className="nav user-area-nav">
            <li className="account">
              <center>
              <div href="#" style={{ color: '#fff', cursor: 'pointer' }} id="profileinfo" onClick={() => profileinfo()}>
                <h3 style={{ fontWeight: 'lighter' }}>Olá, {data ? data.name : ''}! <FaChevronDown size="10"/></h3>
                <div style={{ display: 'none' }}  id="drop-contentp">
                  <a href="#1">Editar Detalhes da Conta</a>
                  <a href="#1">Alterar Senha</a>
                  <a href="#1" onClick={() => sair()}>Sair</a>
                </div>
              </div><br/>
              <Link to="/dashboard"><button><FaHome/>&nbsp;Área de Jogador</button></Link>
              <button><FaInfo/>&nbsp;Suporte</button>
              </center>
             </li>
          </ul>
        </div>
      </Be>
    </>
  );
}